import ROUTE_NAMES from '@/vue/routes/routeNames';
import SECTION_NAMES from '@/vue/routes/sectionNames';
import { usePermissionsStore } from '@/vue/stores/permissions';
import { SESSION_TRACK_ACCESS_DENIED_MESSAGE } from './sessionTrackAccess';

import CueIcon from '@/images/cue.svg?component';

const meta = {
    title: SECTION_NAMES.SESSION_TRACKS,
    icon: CueIcon,
    permissions: (): string[] => [usePermissionsStore().allPermissions.adminCue],
};

const sessionTrackMeta = {
    ...meta,
    deniedMessage: SESSION_TRACK_ACCESS_DENIED_MESSAGE,
};

const SessionEdit = import('@/vue/views/admin/Cue/Session/SessionEdit.vue');

export default [
    {
        path: 'cue/session-tracks',
        name: ROUTE_NAMES.ADMIN_SESSION_TRACK,
        redirect: { name: ROUTE_NAMES.ADMIN_SESSION_TRACK_LIST },
        meta,
        children: [
            {
                path: 'list',
                name: ROUTE_NAMES.ADMIN_SESSION_TRACK_LIST,
                component: () => import('@/vue/views/admin/Cue/SessionTrack/SessionTrackList.vue'),
                meta,
            },
            {
                path: 'new',
                name: ROUTE_NAMES.ADMIN_SESSION_TRACK_NEW,
                component: () => import('@/vue/views/admin/Cue/SessionTrack/SessionTrackNew.vue'),
                meta,
            },
            {
                path: ':id/view',
                name: ROUTE_NAMES.ADMIN_SESSION_TRACK_VIEW,
                props: true,
                component: () => import('@/vue/views/admin/Cue/SessionTrack/SessionTrackView.vue'),
                meta: sessionTrackMeta,
            },
            {
                path: ':sessionTrackId/sessions',
                redirect: { name: ROUTE_NAMES.ADMIN_SESSION_TRACK_VIEW },
                meta: sessionTrackMeta,
                children: [
                    {
                        path: 'new',
                        name: ROUTE_NAMES.ADMIN_SESSION_NEW,
                        props: true,
                        component: () => SessionEdit,
                        meta: sessionTrackMeta,
                    },
                    {
                        path: ':id/edit',
                        name: ROUTE_NAMES.ADMIN_SESSION_EDIT,
                        props: true,
                        component: () => SessionEdit,
                        meta: sessionTrackMeta,
                    },
                ],
            },
        ],
    },
];
